import { createFileRoute, redirect } from '@tanstack/react-router'

// User management moved into the Administration hub as the Access tab.
export const Route = createFileRoute('/_app/organization/users')({
  beforeLoad: () => {
    throw redirect({ to: '/organization/admin/access', search: true })
  },
})
